import { map, each } from "lodash"
import { app } from "../utils/store"

// Carousel
import CarouselAwards from "../modules/carousel/awards"
import CarouselAccessories from "../modules/carousel/accessories"
import CarouselBackground from "../modules/carousel/background"
import CarouselDesigners from "../modules/carousel/designers"
import { CarouselNowadays, CarouselHonorable } from "../modules/carousel/honorable"
import CarouselFlagship from "../modules/carousel/flagship"
import CarouselGalleryAuto from "../modules/carousel/gallery"
import CarouselInfiniteAutoplay from "../modules/carousel/infinte-autoplay"
import CarouselMansory from "../modules/carousel/mansory"
import CarouselParallax from "../modules/carousel/parallax"
import CarouselRelated from "../modules/carousel/related"
import CarouselVariants from "../modules/carousel/variants"
import CarouselVersions from "../modules/carousel/versions"
import CarouselStatusbar from "../modules/carousel/statusbar"
// Gallery
import Gallery from '../modules/Gallery'

// Slider
import Slider from '../modules/Slider'

// Hero
import { Hero, HeroAuto, HeroLanding } from "../modules/hero/hero"

// Gallery
import GalleryProduct from "../modules/gallery/product"

import Forms from "../modules/forms/forms"
import Filters from "../modules/filters"
// import Gallery from '../modules/gallery/gallery'

import Product from "../modules/carousel/versions"
import ContentHub from "../modules/content-hub/content-hub"
import Controls from "../modules/video/controls"
import Modal from "../modules/modal/modal"
import Creative from "../modules/creative/creative"

import LightBox from "../modules/lightbox"

// Async Pagination
import Pagination from "../modules/pagination"
// import Promotions from "../modules/promotions"
import Newsletter from "../modules/newsletter"

import Search from "../modules/search"


export default class Renderer {
    constructor() {
        app.body = document.body
        app.content = document.getElementById("app")

        this.buttons = {
            default: document.querySelectorAll(".btn-default"),
        }

        this.carousel = {
            awards: document.querySelector('[data-carousel="awards"]'),
            accessories: document.querySelector('.carousel[data-carousel="accessories"]'),
            background: document.querySelector('.carousel[data-carousel="background"]'),
            designers: document.querySelector('.carousel[data-carousel="designers"]'),
            honorable: document.querySelector('.carousel[data-carousel="honorable"]'),
            nowadays: document.querySelector('.carousel[data-carousel="nowadays"]'),
            infinte: document.querySelector('.carousel[data-carousel="infinite-autoplay"]'),
            flagship: document.querySelector('.carousel[data-carousel="flagship"]'),
            gallery: document.querySelector('.carousel[data-carousel="gallery-auto"]'),
            mansory: document.querySelector('.carousel[data-carousel="mansory"]'),
            parallax: document.querySelector('.carousel[data-carousel="parallax"]'),
            related: document.querySelector('.carousel[data-carousel="related"]'),
            variants: document.querySelector('.carousel[data-carousel="variants"]'),
            versions: document.querySelectorAll('.carousel[data-carousel="versions"]'),
            quotes: document.querySelector('.carousel[data-carousel="quotes"]'),
            statusbar: document.querySelector('.carousel[data-carousel="statusbar-promo"]'),
        }

        this.slider = {
            gallery: document.querySelectorAll('.slider[data-slider="gallery"]'),
            product: document.querySelectorAll('section.cta--slider-products'),
            hero: document.querySelectorAll('section.hero--homepage-slider')
        }

        this.contentHub = document.querySelector("section.content-hub")

        this.hero = {
            default: document.querySelector("section.hero"),
            auto: document.querySelector("section.hero--auto"),
            landing: document.querySelector("section.hero--landing")
        }

        this.filters = document.getElementById("filters")

        this.gallery = {
            product: document.querySelector('.carousel[data-carousel="gallery-product"]'),
        }

        this.header = document.querySelector("header")
        this.modal = document.querySelector(".btn-modal")
        this.menu = document.getElementById("main-menu")
        this.creative = document.querySelector('.carousel[data-carousel="creative"]')
        this.video = document.querySelector("video")
        this.filters = document.querySelector("[data-filters].parameters")
        this.form = document.querySelector('[role="form"]')
        this.search = document.getElementById("search-toggler")

        this.lightbox = document.querySelector("ol.lightbox")

        this.product = document.querySelector("section.single-product")
        this.line_slider = document.querySelector(".page-line")

        this.pagination = document.querySelector("[data-pagination-async]")
        // this.promotions = document.getElementById('active-promotions')
        this.newsletter = document.getElementById('active-newsletter')

        this.post = {
            test: document.querySelector(".page-test-article"),
        }
    }

    init() {
        if (this.carousel) {
            if (this.carousel.awards) {
                this.carousel.awards = new CarouselAwards({ element: this.carousel.awards })
            }
            if (this.carousel.accessories) {
                this.carousel.accessories = new CarouselAccessories()
            }
            if (this.carousel.background) {
                this.carousel.background = new CarouselBackground()
            }
            if (this.carousel.designers) {
                this.carousel.designers = new CarouselDesigners()
            }
            if (this.carousel.honorable) {
                this.carousel.related = new CarouselHonorable()
            }
            if (this.carousel.nowadays) {
                this.carousel.related = new CarouselNowadays()
            }
            if (this.carousel.infinte) {
                this.carousel.infinte = new CarouselInfiniteAutoplay()
            }
            if (this.carousel.flagship) {
                this.carousel.flagship = new CarouselFlagship()
            }
            if (this.carousel.gallery) {
                this.carousel.gallery = new CarouselGalleryAuto()
            }
            if (this.carousel.mansory) {
                this.carousel.mansory = new CarouselMansory()
            }
            if (this.carousel.parallax) {
                this.carousel.parallax = new CarouselParallax()
            }
            if (this.carousel.related) {
                this.carousel.related = new CarouselRelated()
            }
            if (this.carousel.variants) {
                this.carousel.variants = new CarouselVariants()
            }
            if (this.carousel.versions) {
                each(this.carousel.versions, (carousel) => {
                    return new CarouselVersions(carousel)
                })
            }
            if (this.carousel.quotes) {
                this.carousel.quotes = new CarouselQuotes()
            }
            if (this.carousel.statusbar) {
                this.carousel.statusbar = new CarouselStatusbar()
            }
        }

        if (this.slider) {
            if (this.slider.gallery) {
                each(this.slider.gallery, (slider) => {
                    return new Gallery({ element: slider })
                })
            }

            if (this.slider.product) {
                each(this.slider.product, (slider) => {
                    return new Slider({ element: slider })
                })
            }

            if (this.slider.hero) {
                each(this.slider.hero, (slider) => {
                    return new Slider({ element: slider })
                })
            }
        }

        if (this.creative) {
            this.creative = new Creative()
        }

        if (this.contentHub) {
            this.contentHub = new ContentHub()
        }

        if (this.filters) {
            this.filters = new Filters()
        }

        if (this.form) {
            this.form = new Forms()
        }

        if (this.gallery.product) {
            this.gallery.product = new GalleryProduct()
        }

        if (this.hero.default) {
            this.hero.default = new Hero()
        } else if (this.hero.auto) {
            this.hero.auto = new HeroAuto()
        } else if (this.hero.landing) {
            this.hero.landing = new HeroLanding()
        }

        if (this.kind) {
            this.kind = new Kind()
        }

        if (this.lightbox) {
            this.lightbox = new LightBox()
        }

        if (this.modal) {
            this.modal = new Modal()
        }

        if (this.pagination) {
            this.pagination = new Pagination()
        }

        if (this.product) {
            this.product = new Product()
        }

        // if (this.promotions) {
        //     this.promotions = new Promotions()
        // }

        if (this.newsletter) {
            this.newsletter = new Newsletter()
        }

        if (this.search) {
            this.search = new Search()
        }

        if (this.video) {
            this.controls = new Controls()
        }
    }

    destroy = () => {
        console.log("Destroy Components")
        // Destroy Components using JS
    }
}
